module.exports = __webpack_public_path__ + "static/media/05.dcfd524d.jpg";